/* ---------------------------------------------------------------------------
   Custom footer — mobile accordion behaviour.

   2026-09-08 (audit SITE-08 / PDP-18): extracted verbatim from
   sections/custom-footer.liquid, where it was inlined into every HTML document
   on the site. No Liquid values, so nothing had to stay behind. Loaded with
   `defer`, which keeps the original run order (after the footer markup parses).
   --------------------------------------------------------------------------- */
(function() {
    var BP = 750;
    var DURATION = 350;
    var groups = document.querySelectorAll('.cf-nav__group');

    /* Set initial state based on viewport */
    function sync() {
      var isDesktop = window.innerWidth >= BP;
      groups.forEach(function(el) {
        var tog = el.querySelector('.cf-nav__toggle');
        el.classList.remove('is-closing');
        if (isDesktop) {
          el.setAttribute('open', '');
          tog.style.pointerEvents = 'none';
        } else {
          el.removeAttribute('open');
          tog.style.pointerEvents = '';
        }
      });
    }

    /* Animate close: slide shut, then remove open attribute */
    function animateClose(el) {
      if (!el.open || el.classList.contains('is-closing')) return;
      el.classList.add('is-closing');
      setTimeout(function() {
        el.removeAttribute('open');
        el.classList.remove('is-closing');
      }, DURATION);
    }

    sync();

    var resizeTimer;
    window.addEventListener('resize', function() {
      clearTimeout(resizeTimer);
      resizeTimer = setTimeout(sync, 100);
    });

    /* Exclusive accordion — only one open at a time on mobile */
    groups.forEach(function(el) {
      var tog = el.querySelector('.cf-nav__toggle');

      tog.addEventListener('click', function(e) {
        if (window.innerWidth >= BP) { e.preventDefault(); return; }

        if (el.open && !el.classList.contains('is-closing')) {
          e.preventDefault();
          animateClose(el);
        } else {
          setTimeout(function() {
            groups.forEach(function(sibling) {
              if (sibling !== el && sibling.open) {
                animateClose(sibling);
              }
            });
          }, 10);
        }
      });
    });
  })();
